import { FC, ReactNode } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon, SvgHelperWrapper } from 'src/components';
import Star from '../../assets/star.svg';
import * as S from './styles';

const msgs = defineMessages({
  desktopTitle: {
    id: 'new_plans_hero_title',
    defaultMessage: 'A whole new culture.{br}For less than a <strong>coffee a day</strong>.',
  },
  eyebrow: {
    id: 'new_plans_panel_eyebrow',
    defaultMessage: 'MEMRISE PRO',
  },
  mobileTitle: {
    id: 'new_plans_panel_title',
    defaultMessage: 'Fluent from <em>just {pricePerDay}/day</em>',
  },
  subLine: {
    id: 'new_plans_hero_sub',
    defaultMessage: '<strong>Join 370,000 learners</strong> going PRO',
  },
  mobileSubText: {
    id: 'new_plans_hero_mobile_sub',
    defaultMessage: 'A whole new culture. For less than a <strong>coffee a day</strong>.',
  },
  bullet1: {
    id: 'new_plans_hero_bullet_1',
    defaultMessage: 'AI conversation practice',
  },
  bullet2: {
    id: 'new_plans_hero_bullet_2',
    defaultMessage: 'Grammar & verb drills',
  },
  bullet3: {
    id: 'new_plans_hero_bullet_3',
    defaultMessage: 'Ad-free',
  },
  quote: {
    id: 'new_plans_hero_quote',
    defaultMessage:
      '"I just had an honest-to-god conversation in French with a friend in Quebec, because of Memrise!"',
  },
  quoteAuthor: {
    id: 'new_plans_hero_quote_author',
    defaultMessage: 'Emma · PRO member',
  },
  logoAlt: {
    id: 'memrise_logo_link_alt_text',
  },
});

const bold = (...chunks: ReactNode[]) => <strong key="bold">{chunks}</strong>;

const STAR_KEYS = ['star-1', 'star-2', 'star-3', 'star-4', 'star-5'];

export const HeroSection: FC<{
  onBack?: () => void;
  pricePerDay?: string;
}> = ({ onBack, pricePerDay }) => {
  const intl = useIntl();

  return (
    <S.HeroContainer data-testid="new-hero-section">
      <div>
        <S.LogoWrapper>
          {onBack && (
            <S.BackButton onClick={onBack} aria-label="Back">
              ←
            </S.BackButton>
          )}
          <Icon name="memrise" />
        </S.LogoWrapper>

        <S.MobileEyebrow>{intl.formatMessage(msgs.eyebrow)}</S.MobileEyebrow>
        <S.MobileTitle>
          {intl.formatMessage(msgs.mobileTitle, {
            pricePerDay: pricePerDay || '…',
            em: (...chunks: ReactNode[]) => <em key="em">{chunks}</em>,
          })}
        </S.MobileTitle>

        <S.DesktopTitle>
          {intl.formatMessage(msgs.desktopTitle, {
            br: <br key="br" />,
            strong: bold,
          })}
        </S.DesktopTitle>
        <S.SubLine>{intl.formatMessage(msgs.subLine, { strong: bold })}</S.SubLine>
        <S.BulletList>
          <S.BulletItem>{intl.formatMessage(msgs.bullet1)}</S.BulletItem>
          <S.BulletItem>{intl.formatMessage(msgs.bullet2)}</S.BulletItem>
          <S.BulletItem>{intl.formatMessage(msgs.bullet3)}</S.BulletItem>
        </S.BulletList>
        <S.Divider />
        <S.MobileSubText>
          {intl.formatMessage(msgs.mobileSubText, { strong: bold })}
        </S.MobileSubText>
      </div>

      <S.QuoteBlock>
        <S.Stars>
          {STAR_KEYS.map(key => (
            <SvgHelperWrapper Svg={Star} key={key} />
          ))}
        </S.Stars>
        <S.QuoteText>{intl.formatMessage(msgs.quote)}</S.QuoteText>
        <S.QuoteAuthor>{intl.formatMessage(msgs.quoteAuthor)}</S.QuoteAuthor>
      </S.QuoteBlock>
    </S.HeroContainer>
  );
};
